// src/hooks/convy/brushes/helpers/brushLoader.js

import {
  addTextureCache,
  getTextureFromCache,
  getTexturesForBrush,
} from '../../../../utils/caching/indexedDBcache'; // Импортируем функции для работы с текстурами в IndexedDB


export const brushDefaults = {
  test: {
    opacity: 0.6,
    wobble: 0.08,
    density: 1.2,
    dryEdges: 0.7, // Strength of pigment accumulation at edges
    bloom: 0.3, // Soft diffusion effect
    granulation: 0.4, // Texture variation
    taperLength: 3,
    taperWidth: 0.2,
    flatEdges: false,
    autoRotation: true,
    angle: 0,
    edgeStep: 6,
    textureStrength: 0.0,
    baseScaleFactor: 40,

    pressureAvailable: true,

  },


  pixels: {
    pixelSize: 20,
    borderWidth: 0,
    borderColor: '#000000',
    outsideBorders: false,
    showPixelGrid: true,
    pressureOn: false,

    pressureAvailable: true,
  },
  common: {
    smoothing: 0,
    squareBrush: false,
    magnifierButton: false,
    brushMagnifier: false,
    eraserMagnifier: false,
    pressureOn: true,
    sensitivity: 1,
    pressureCoef: 1,
    pressureExponent: 1.5,
    minimalPressure: 0,

    showCommonGrid: false,
    gridSize: 50,
    referenceGridSize: 50,
  },

  liner: {
    pressureAvailable: false,
  },
  plain: {
    pressureAvailable: true,
  },
  stylus: {
    pressureAvailable: true,
  },
  shape: {
    figure: 'line',
    brush: 'plain',
    shape: true,
  },
  outlined: {
    outlineSize: 5,
    outlineColor: '#000000FF',
    outlineOpacity: 1,
    pressureAvailable: true,
  },
  dashed: {
    dashSize: 3,
    gapSize: 5,
  },
  spray: {
    softness: 0.3,
    pressureAvailable: true,
    pressureOn: false,
  },
  bristle: {
    wobble: 0.05,
    ragged: 0,
    opacity: 0.3,
    pressureAvailable: true,
    pressureOn: true,
  },
  wet: {
    wobble: 0.00,
    density: 0.5,
    dryEdges: 1,

    flatEdges: false,
    flatness: 3,
    autoRotation: true,
    angle: 0,

    taperWidth: 0,
    taperLength: 2,
    opacity: 0.8,
    pressureAvailable: true,
    pressureOn: true,
    textureStrength: 0.2,

    
  },
  smudge: {
    opacity: 0.28,
    flow: 0.6,
    blending: 0.72,
    softness: 0.58,
    density: 0.65,
    intensity: 0.5,
    dragLength: 1,
    pressureAvailable: true,
    pressureOn: true,
  },
  blur: {
    blurStrength: 0.55,
    pressureAvailable: true,
    pressureOn: false,
  },
  blender: {
    opacity: 0.28,
    flow: 0.6,
    blending: 0.72,
    softness: 0.58,
    density: 0.65,
    intensity: 0.5,
    dragLength: 1,
    pressureAvailable: true,
    pressureOn: true,
  },
  flat: {
    opacity: 1,

    wobble: 0.00,
    weight: 0.75,
    density: 0.6,
    dryEdges: 1,
    baseScaleFactor: 30,

    flatness: 3,
    autoRotation: true,
    angle: 0,

    pressureAvailable: true,
    pressureOn: true,
    textureStrength: 0.2,

    tailLength: 0,
    bristleBreakup: 0.5,
  },
  // Новая кисть: Бархатная пастель
  velvetPastel: {
    opacity: 1,
    weight: 1,
    density: 1.0,
    granuleSkipping: 0.5,
    granuleSize: -0.3,
    baseScaleFactor: 60,
    jitter: 0,

    proportionalTail: false,
    tailLength: 2.0,
    tailRelativeLength: 0.5,

    softCore: 0.4,
    centerSoftness: 0.8,
    centerAlphaCut: 0.16,
    coreRadiusGrow: 0.9,
    smear: 0.16,
    corePack: 0.7,
    ovality: 1.25,
    maxOffsetsBase: 900,
    powder: 0.9,
    splinterRate: 0.45,
    splinterLenMax: 0.14,
    splinterAngleJitter: 0.18,
    speedDownsample: 0.6,
    pressureDownsample: 0.5,

    pressureAvailable: true,
    pressureOn: true,
  },

  waterSpread: {
    opacity: 0.5,
    // --- Физика Акварели ---
    wetness: 0,           // "Мокрость": влияет на прозрачность
    edgeConcentration: 0.33, // "Эффект кофейного пятна"
    bleeding: 0.3,          // Растекание внутренних слоев
    
    edgeWidth: 0.7,         
    edgeWobbleScale: 0.2,  
    edgeWobbleAmount: 0.3,  
    
    // --- Сужение и Концы (Caps) ---
    taperStart: 0.2,
    taperEnd: 0.2,
    taperPressure: 0.6,
    
    // Настройки формы концов
    capWidth: 0.5,     // 0.0 - 1.0. Ширина начала тела кисти относительно максимума
    taperStartEnabled: false,  

    capDetail: 10,      
    
    // --- Оптимизация ---
    edgeStep: 3,     

    pressureAvailable: true,
    pressureOn: false,
  },
  waterSoft: {
    opacity: 0.5,
    bleeding: 0.3,          // Растекание внутренних слоев
    layerSpread: 0.5,
    layerCount: 20,    
    substrateSize: 1,

    taperStart: 0.2,
    taperEnd: 0.2,
    
    // Настройки формы концов
    capWidth: 0.7,     // 0.0 - 1.0. Ширина начала тела кисти относительно максимума
    taperStartEnabled: false,  

    edgeWidth: 0.7,         
    edgeOffset: 0.8,
    edgeOpacity: 0.15,
    // --- Оптимизация ---
    edgeStep: 3,     

    pressureAvailable: true,
    pressureOn: true,
  },
  feather: {
    speedDependence: false,

    centralWidth: 0.4,
    
    minWidthStart: 0.01,
    taperStartPoint: 0.5,
    minWidthEnd: 0.01,
    taperEndPoint: 0.5,

    transparentEdges: false,
    opacityOnStart: 0,
    fadeStartPoint: 0.3,
    opacityOnEnd: 0,
    fadeEndPoint: 0.7,
  },
  ink: {
    speedDependence: false,

    edgeWidening: true,
    centralWidth: 0.4,
    
    minWidthStart: 1,
    taperStartPoint: 0.5,
    minWidthEnd: 1,
    taperEndPoint: 0.5,

    transparentEdges: false,
    opacityOnStart: 0,
    fadeStartPoint: 0.3,
    opacityOnEnd: 0,
    fadeEndPoint: 0.7,
  },
  watercolor: {
    textureOn: true,
    texture: 'waterAi',
    opacity: 0.7,
    spreading: true,
    textureScale: 1,
    waterBlurSize: 15,
    waterBlurAlpha: 0.8,

    outline: true,
    outlineSize: 2,
    outlineOpacity: 0.7,

    pressureAvailable: true,
    pressureOn: false,
  },

  pencil: {
    textureOn: true,
    texture: 'basic',
    opacity: 0.8,
    outline: true,
    textureScale: 1,

    tapering: false,
    minWidthStart: 0.6,
    taperStartPoint: 0.5,
    minWidthEnd: 0.6,
    taperEndPoint: 0.5,

    transparentEdges: false,
    opacityOnStart: 0,
    fadeStartPoint: 0.5,
    opacityOnEnd: 0,
    fadeEndPoint: 0.5,

    pressureAvailable: true,
    pressureOn: false,
  },
  oil: {
    textureOn: true,
    texture: 'fabric',

    speedDependence: true,
    minWidthStart: 0.3,
    taperStartPoint: 0.5,
    minWidthEnd: 0.3,
    taperEndPoint: 0.5,
    opacity: 1,
    textureScale: 1,

    pressureAvailable: true,
    pressureOn: false,
  },

  rembrandt: {
    cutEdges: true,
    density: 0.5,
    tapering: 0.5,
    wobble: 0,
    opacity: 1,
    ragged: 1,
    shadowStrength: 0.5,
    ropeEffect: false,

    pressureAvailable: true,
    pressureOn: true,

  },

  neon: {
    neonSize: 25,
    opacity: 0.75,
  },
  sparkle: {
    highDensity: false,
    bigSizes: false,
    sparkleDensity: 0.5,
    sparkleSize: 1, 
    sparkleDistributionPower: 0.8, 
    sparkleShape: 'square', 
    opacity: 1, 

    pressureAvailable: true,
  },
  glyph: {
    pressureAvailable: true,
    pressureOn: true,
    pressureOpacity: false,
    glyphRotation: false,
    opacity: 1, 
    enhance: true,
    stepSize: 1,
    highTransparency: false, 
    shadowStrength: 0,
    shadowColor: '#000000FF',
  },
  filler: {
    tolerance: 5,
    antialiasing: 5,
    eatEdges: false,
  },
  pixelate: {
    size: 20,
    sizeX: 20,
    sizeY: 20,
  },
  texture: {
    textureOn: true,
    texture: 'waterAi',
    textureScale: 1,
    opacity: 0.2,
    blending: 0.2,
    composition: 'luminosity',
  },
  
}


export const sources = {
  texture: {
    waterAi: {
      stroke: '/draw/textures/water-ai-400.png',
      light: '/draw/textures/water-ai-400-l.png',
    },
    naturalPaper: {
      stroke: '/draw/textures/natural-paper.png',
      light: '/draw/textures/natural-paper-l2.png',
    },
    paper: {
      stroke: '/draw/textures/paper.png',
      light: '/draw/textures/paper-l.png',
    },
    pencil: {
      stroke: '/draw/textures/pencil-150.png',
      light: '/draw/textures/pencil-150.png',
    },
    graphite: {
      stroke: '/draw/textures/graphite-250.png',
      light: '/draw/textures/graphite-250.png',
    },
    fabric: {
      stroke: './draw/textures/fabric.png',
      light: './draw/textures/fabric.png',
    },
 
  },
  backup: {
    diagonal: {
      stroke: '/draw/textures/diagonal-striped-brick.png',
    }
  },
  watercolor: {
    waterAi: {
      stroke: '/draw/textures/water-ai-400.png',
      light: '/draw/textures/water-ai-400-l.png',
    },
    naturalPaper: {
      stroke: '/draw/textures/natural-paper.png',
      light: '/draw/textures/natural-paper-l2.png',
    },
    paper: {
      stroke: '/draw/textures/paper.png',
      light: '/draw/textures/paper-l.png',
    },
    // paper1: {
    //   stroke: '/draw/textures/test/paper-1.png',
    //   light: '/draw/textures/test/paper-1.png',
    // },
    // paper2: {
    //   stroke: '/draw/textures/test/paper-2.png',
    //   light: '/draw/textures/test/paper-2.png',
    // },
  },
  pencil: {
    basic: {
      stroke: '/draw/textures/pencil-150.png',
    },
    graphite: {
      stroke: '/draw/textures/graphite-250.png',
    },
    // basic200: {
    //   stroke: '/draw/textures/pencil-200.png',
    // },
  },
  oil: {
    fabric: {
      stroke: './draw/textures/fabric.png',
    },
  },
};





const textures = {};

/**
 * Загружает текстуру с сервера как HTMLImageElement.
 * @param {string} src - URL текстуры.
 * @returns {Promise<HTMLImageElement>} - Изображение.
 */
function loadTexture(src) {
  window.logPerformance?.(`Texture loading STARTED: ${src}`);
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      window.logPerformance?.(`Texture loading FINISHED: ${src}`);
      resolve(image);
    };
    image.onerror = reject;
    image.src = src;
  });
}

async function imageToBlob(image) {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, 0, 0);
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, 'image/png');
  });
}

async function blobToImage(blob) {
  const url = URL.createObjectURL(blob);
  const image = new Image();
  return new Promise((resolve, reject) => {
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image from blob'));
    };
    image.src = url;
  });
}

export async function getTexture(brush, base, type = 'stroke') {

  if (textures[brush]?.[base]?.[type]) {
    return textures[brush][base][type];
  }

  window.croco?.log(`🌐 Getting texture: ${brush}/${base}/${type}`);

  const src = sources[brush]?.[base]?.[type];
  if (!src) {
    window.croco?.log(`❓ Texture not found: ${brush}/${base}/${type}`);
    return await getTexture('backup', 'diagonal', 'stroke');
  }

  // Пытаемся загрузить текстуру из IndexedDB
  let cachedBlob = null;
  try {
    cachedBlob = await getTextureFromCache({ brushName: brush, textureName: base, type });
  } catch (error) {
    window.croco?.log(`❗️ Failed to load texture from IndexedDB cache for ${brush}/${base}/${type}:`, error);
  }

  let image;
  if (cachedBlob) {
    try {
      image = await blobToImage(cachedBlob);
      window.croco?.log(`📂 Texture loaded from cache: ${brush}/${base}/${type}`);
    } catch (error) {
      window.croco?.log(`❗️ Failed to convert cached blob to image for ${brush}/${base}/${type}:`, error);
      image = null; // Если преобразование не удалось, попробуем загрузить из сети
    }
  }

  if (!image) {
    // Загружаем текстуру из сети с помощью loadTexture

    try {
      image = await loadTexture(src);
      window.croco?.log(`⬇️ Texture loaded from server: ${brush}/${base}/${type} from ${src}`);
    } catch (e) {
      window.croco?.log(`❗️ Failed to load texture from server for ${brush}/${base}/${type} from ${src}`, e);
    }

    // Сохраняем текстуру в IndexedDB как Blob
    try {
      const blob = await imageToBlob(image);
      await addTextureCache({ brushName: brush, textureName: base, type, blob });
      window.croco?.log(`💾 Texture cached in IndexedDB: ${brush}/${base}/${type}`);
    } catch (error) {
      window.croco?.log(`❗️ Failed to cache texture in IndexedDB for ${brush}/${base}/${type}:`, error);
    }
  }

  if (!textures[brush]) textures[brush] = {};
  if (!textures[brush][base]) textures[brush][base] = {};
  textures[brush][base][type] = image;

  return image;
}



export async function preloadTextures(brushName, textureName) {
  if (!sources[brushName]) {
    throw new Error(`Brush "${brushName}" not found in sources`);
  }

  const texturesToLoad = {};

  if (!textureName) {
    for (const [tName, tValue] of Object.entries(sources[brushName])) {
      texturesToLoad[tName] = tValue;
    }
  } else {
    if (!sources[brushName][textureName]) {
      throw new Error(`Texture "${textureName}" not found for brush "${brushName}"`);
    }
    texturesToLoad[textureName] = sources[brushName][textureName];
  }

  for (const [tName, tValue] of Object.entries(texturesToLoad)) {
    for (const type of Object.keys(tValue)) {
      await getTexture(brushName, tName, type)
    }
  }

  window.croco?.log(`🔰 All textures preloaded for brush "${brushName}${textureName ? `, texture "${textureName}"` : ''}`);

}

